import FlexibleTable from "src/shared/components/data-display/FlexibleTable/FlexibleTable"

import "./Estancia.css"
import { EstanciaRow } from "../resumen/hooks/useGetEstanciaRows"
import { Habitacion, TiposAlojamientos, TiposExtras } from "src/gql/schema"

const Estancia = ({
    pagosList,
    total,
    habitacion
}: {
    pagosList: EstanciaRow[]
    total: string
    habitacion: Habitacion
}) => {
    const isMotel = habitacion?.ultima_renta?.tipo_alojamiento === TiposAlojamientos.Motel

    return (
        <div className="room-detail__page--checkout-tab-estancia__wrapper">
            <div className="room-detail__page--checkout-tab-estancia__table">
                <FlexibleTable
                    sticky={true}
                    emptyState={{headerIcon: "HotelFilled"}}
                    tableItems={{
                        headers: [
                            {
                                value: "Concepto",
                            },
                            {
                                value: "Tarifa",
                            },
                            {
                                value: "Cantidad",
                            },
                            {
                                value: "IVA",
                            },
                            {
                                value: "Total",
                            },
                            {
                                value: "Status",
                            },
                        ],
                        rows:
                            pagosList?.map((pago) => ({
                                value: [
                                    { value: <>{pago?.concepto}</> },
                                    { value: <>{pago?.tarifa}</> },
                                    { value: <>{pago?.cantidad}</> },
                                    { value: <>{pago?.iva}</> },
                                    {
                                        value: (
                                            <>
                                                {pago?.total}
                                                {pago.tipo_extra === TiposExtras.Persona && (
                                                    <span style={{
                                                        color: "var(--Placeholder, #667085)",
                                                        fontFamily: "Montserrat",
                                                        fontSize: "10px",
                                                        fontStyle: "normal",
                                                        fontWeight: 600,
                                                        lineHeight: "20px",
                                                        display: "block",
                                                    }}>
                                                        (x {pago.noches} {isMotel ? (pago.noches === 1 ? "estancia" : "estancias") : (pago.noches === 1 ? "noche" : "noches")})
                                                    </span>
                                                )}
                                            </>
                                        ),
                                    },
                                    { value: <>{pago?.status}</> },
                                ],
                            })) || [],
                    }}
                />
            </div>
            <div className="room-detail__page--checkout-tab-estancia-total-wrapper">
                <div className="room-detail__page--checkout-tab-estancia-total">
                    <span>Total</span>
                    <span>{total}</span>
                </div>
            </div>
        </div>
    )
}

export default Estancia
